module.exports = __webpack_public_path__ + "img/ads-spend.fd08aa86.svg";